"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuessSprite = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const blocks_1 = require("../blocks");
const pixi_js_1 = require("pixi.js");
const question_svg_1 = __importDefault(require("../../assets/svg/question.svg"));
const question_error_svg_1 = __importDefault(require("../../assets/svg/question_error.svg"));
const question_white_svg_1 = __importDefault(require("../../assets/svg/question_white.svg"));
const Global_1 = require("../Global");
const gsap_1 = require("gsap");
class GuessSprite extends blocks_1.Block {
    constructor(app, repeats = 1) {
        super(app);
        this.repeats = repeats;
        this.questionSprite = pixi_js_1.Sprite.from(question_svg_1.default);
        this.questionSprite.anchor.set(0.5, 0.5);
        this.questionLeft = pixi_js_1.Sprite.from(question_error_svg_1.default);
        this.questionRight = pixi_js_1.Sprite.from(question_white_svg_1.default);
        this.questionLeft.anchor.set(0.5, 0.5);
        this.questionRight.anchor.set(0.5, 0.5);
        this.tm = gsap_1.gsap.timeline({ paused: true }).to(this.questionSprite, {
            pixi: {
                positionY: (0, Global_1.px)(this.overSmallSize ? -8 : -6),
                scaleY: (0, Global_1.px)(this.overSmallSize ? 0.135 : 0.145)
            },
            duration: 0.3,
            ease: "power1.out",
            yoyo: true,
            repeat: this.repeats
        }).to(this.questionLeft, {
            pixi: {
                positionY: (0, Global_1.px)(this.overSmallSize ? -4 : -3),
                positionX: (0, Global_1.px)(this.overSmallSize ? -21 : -18),
                scaleY: (0, Global_1.px)(this.overSmallSize ? 0.134 : 0.11)
            },
            duration: 0.4,
            ease: "power1.out",
            yoyo: true,
            delay: 0.1,
            repeat: this.repeats
        }, '<').to(this.questionRight, {
            pixi: {
                positionY: (0, Global_1.px)(this.overSmallSize ? -4 : -3),
                positionX: (0, Global_1.px)(this.overSmallSize ? 21 : 18),
                scaleY: (0, Global_1.px)(this.overSmallSize ? 0.134 : 0.11)
            },
            duration: 0.3,
            ease: "power1.out",
            yoyo: true,
            delay: 0.15,
            repeat: this.repeats
        }, '<');
        this.tms.add(this.tm);
        this.addChild(this.questionLeft, this.questionRight, this.questionSprite);
        this.layout();
    }
    play() {
        this.tm.play(this.tm.progress() === 1 ? 0 : null);
    }
    stop() {
        if (this.tm.progress() !== 1 && this.tm.progress() > 0) {
            this.tm.reverse();
        }
        else {
            this.tm.pause(0);
        }
    }
    layout() {
        super.layout();
        this.questionSprite.scale.set((0, Global_1.px)(this.overSmallSize ? 0.15 : 0.13));
        this.questionLeft.position.set((0, Global_1.px)(this.overSmallSize ? -20 : -17), 0);
        this.questionLeft.rotation = -.3;
        // this.questionLeft.alpha = 0.75;
        this.questionLeft.scale.set((0, Global_1.px)(this.overSmallSize ? 0.12 : 0.10));
        this.questionRight.position.set((0, Global_1.px)(this.overSmallSize ? 20 : 17), 0);
        this.questionRight.rotation = .3;
        // this.questionRight.alpha = 0.75;
        this.questionRight.scale.set((0, Global_1.px)(this.overSmallSize ? 0.12 : 0.10));
    }
}
exports.GuessSprite = GuessSprite;
